<app-modal *ngIf="vo$ | async ; let vo" class="app-filter-model-config-modal">
	<div modal-body class="app-filter-model-config-modal__body">
		<dc-alert
			class="info"
			type="info"
			message="info"
			i18n-message="@@subscription.profile.config.modal.description">
		</dc-alert>

		<app-card-outline class="filter-model-card">
			<div card-outline-title>
				<span
						i18n="@@subscription.profile.config.filterModel.title">
					filter-model</span>
<!--				<app-doc-hint [docKey]="DocHintKeys.ExpositionQueryParams"></app-doc-hint>-->
			</div>

			<div
				class="filter-model-card__content"
				card-outline-content>
				<form [formGroup]="filterConfigForm.form" class="filter-model-form">
					<mat-form-field [appearance]="Appearance">
						<mat-label
							i18n="@@subscription.profile.config.filterModel.form.label">
							label</mat-label>
						<input
							type="text"
							id="{{ cmpId + '-filterLabel-input' }}"
							matInput
							[formControlName]="FilterModelFormControls.Label" />

						<mat-error
							*ngIf="
							filterConfigForm.form
							.get(FilterModelFormControls.Label)
							?.hasError(ValidationErrorKeys.Maxlength)
						"
							i18n="@@general.form.errors.maxlength">
							max length
						</mat-error>
					</mat-form-field>

					<mat-form-field [appearance]="Appearance">
						<mat-label
							i18n="@@subscription.profile.config.filterModel.form.description">
							description</mat-label>

						<textarea
							type="text"
							[rows]="4"
							id="{{ cmpId + '-filterDescription-input' }}"
							matInput
							[formControlName]="FilterModelFormControls.Description"></textarea>

						<mat-error
							*ngIf="
							filterConfigForm.form
							.get(FilterModelFormControls.Description)
							?.hasError(ValidationErrorKeys.Maxlength)
						"
							i18n="@@general.form.errors.maxlength">
							max length
						</mat-error>
					</mat-form-field>

				</form>

				<dcds-query-builder [isInUTC]="false" [fields]="availableFields"
														[group]="queryFormGroup"></dcds-query-builder>
<!--					<pre>{{ queryFormGroup.value | json }}</pre>-->
				<dcds-query-view [fields]="availableFields" [query]="queryFormGroup.value"></dcds-query-view>
			</div>
		</app-card-outline>
	</div>

	<div
		class="app-filter-model-config-modal__footer"
		modal-footer>
		<div
			*ngIf="vo.error"
			class="error-alert error">
			<mat-icon
				[ngClass]="{ 'warning': vo.error.type === 'warning' }"
				color="warn"
				[svgIcon]="vo.error.type === 'critic'? DcIcons.Error: DcIcons.Warning"></mat-icon>
			<span>{{vo.error.message}}</span>
		</div>

		<button
			id="{{ cmpId }}-save-btn"
			[disabled]="vo.criticErrors !== 0 || filterConfigForm.form.status === 'INVALID' || queryFormGroup.invalid"
			[color]="'primary'"
			(click)="upsertFilterModel()"
			mat-raised-button>
			<span i18n="@@general.action.save">save</span>
		</button>
	</div>
</app-modal>
